(function () {
    'use strict';

    var app = angular.module('intro-app', [
        // Angular modules 
        'ngAnimate',                // animations
        'ngRoute',                  // routing
        'ngSanitize',               // sanitizes html bindings (ex: sidebar.js)
        'ngMessages',               // Validation Messages
        'angularMoment',            // work with date
        'vcRecaptcha',
        'common',                   // common functions, logger, spinner
        'common.bootstrap',         // bootstrap dialog wrapper functions
        'ui.bootstrap',             // ui-bootstrap (ex: carousel, pagination, dialog)
        'infinite-scroll',          // infinite scroll
        'ngCookies',
        'pascalprecht.translate',   //angular translate
        'tmh.dynamicLocale'         //angular-dynamic-locale
    ]);

    // Lodash library
    app.factory('_', ['$window',
          function ($window) {
              // place lodash include before angular
              return $window._;
          }
    ]);

    app.factory('httpInterceptor', function ($q, $rootScope) {
        return {
            request: function (config) {
                $rootScope.loading = true;                
                return config || $q.when(config);
            },
            response: function (config) {
                $rootScope.loading = false;                
                return config || $q.when(config);
            },
            responseError: function (config) {
                $rootScope.loading = false;                
                return config || $q.when(config);
            }
        };
    });

    app.config(function ($httpProvider) {
        $httpProvider.interceptors.push('httpInterceptor');
    });

    app.directive('ccImageLoader', function () {
        var directive = {};

        directive.restrict = 'E'; /* restrict this directive to elements */
        directive.transclude = true;
        directive.templateUrl = "/app/html-templates/loader.html";

        return directive;
    });

    //*************************************************************
    /* Bottone con loader integrato                              */
    //*************************************************************
    app.directive('loaderbutton', function ($rootScope) {
        return {
            restrict: 'E',
            scope: {
                classe: '@',
                label: '@',
                click: '&'
            },
            link: function (scope, element, attrs) {
                scope.$watch(function () {
                    return $rootScope.loading;
                }, function () {
                    scope.scopedLoading = $rootScope.loading;
                }, true);
            },
            templateUrl: '/app/html-templates/loaderButton.html',
            replace: true
        }
    });
  
    // Handle routing errors and success events
    app.run(['amMoment', function (amMoment) {
        // Include $route to kick start the router.
        amMoment.changeLocale('it');
    }]);
})();
